import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState,useEffect } from "react";
import { Alert, Button, Form, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ChevronLeft, ChevronRight, Trash } from "react-bootstrap-icons";
import { FaInfoCircle, FaPlus } from 'react-icons/fa'
import './CreateWorkStation.scss'
import { Workstation } from "../../types"; // Asegúrate de que la ruta sea correcta

interface CreateWorkstationProps {
  moveFunctions: { next: () => void; back: () => void };
  setPayload: (data: Workstation[]) => void;
  accountCode: string;
  workstation: Workstation[]; // Ya no puede ser null
  setWorkstation: (workstation: Workstation[]) => void;
}

// Generador simple de IDs únicos para workstations
const generateWorkstationId = () => `ws_${Date.now()}_${Math.floor(Math.random()*10000)}`;

const CreateWorkstation: React.FC<CreateWorkstationProps> = ({ moveFunctions, setPayload, accountCode, workstation, setWorkstation }) => {
  const storedData = JSON.parse(localStorage.getItem("RegistrationMemory") || "{}");
  const localData = storedData[1] || {}; // Datos del local
  const [newName, setNewName] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [newIsCaja, setNewIsCaja] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showNewForm, setShowNewForm] = useState(false);
  // Estado local para checkboxes
  const [checkedMap, setCheckedMap] = useState<{ [key: string]: boolean }>(() => {
    const map: { [key: string]: boolean } = {};
    workstation.forEach(w => {
      const key = w.workstation_id || w.workstation_name;
      map[key] = true;
    });
    return map;
  });

  useEffect(() => {
  localStorage.setItem('selectedWorkstations', JSON.stringify(checkedMap));
  }, [checkedMap]); 

  
  useEffect(() => {
    const savedCheckedMap = JSON.parse(localStorage.getItem('selectedWorkstations') || '{}');
    if (savedCheckedMap) {
      setCheckedMap(savedCheckedMap);
    }
  }, []); 

  // Sincronizar checkedMap si cambian las workstations (agregar/eliminar)
  React.useEffect(() => {
  setCheckedMap(prev => {
    const map = { ...prev };

    workstation.forEach(w => {
      const key = w.workstation_id || w.workstation_name;
      if (!(key in map)) map[key] = true;
    });

    Object.keys(map).forEach(k => {
      if (!workstation.find(w => (w.workstation_id || w.workstation_name) === k)) {
        delete map[k];
      }
    });
    return map;
  });
}, [workstation]);

  useEffect(() => {
  // Solo si no hay ninguna estación “Caja” en el array, la añadimos automáticamente
  if (!workstation.some(w => w.workstation_name === 'Caja')) {
    setWorkstation([
      ...workstation,
      {
        workstation_name: 'Caja',
        workstation_description: 'Estación de trabajo para realizar transacciones y manejar dinero.',
        default_terminal_id: 0,
        isCaja: true,
        local_id: localData.local_id || '',
        workstation_id: generateWorkstationId(),
        code: accountCode,
      },
    ])

    setCheckedMap(prev => ({ ...prev, 'Caja': true }));
  }
}, []);
  // Marcar/desmarcar estación
  const toggleChecked = (name: string, id?: string) => {
    const key = id || name;
    setCheckedMap(prev => ({ ...prev, [key]: !prev[key] }));
  };

  // Agregar nueva estación
  const addCustomOption = () => {
    if (!newName.trim()) {
      setError("El nombre de la estación no puede estar vacío.");
      return;
    }
    if (workstation.some((w) => w.workstation_name === newName.trim())) {
      setError("Ya existe una estación con ese nombre.");
      return;
    }
    setError(null);
    const newId = generateWorkstationId();
    setWorkstation([
      ...workstation,
      {
        workstation_name: newName.trim(),
        workstation_description: newDesc.trim(),
        default_terminal_id: 0,
        isCaja: newIsCaja,
        local_id: localData.local_id || '',
        workstation_id: newId,
        code: accountCode,
      },
    ]);
    setCheckedMap(prev => ({ ...prev, [newId]: true }));
    setNewName("");
    setNewDesc("");
    setNewIsCaja(false);
  };

  // Eliminar estación
  const removeOption = (name: string, id?: string) => {
    const key = id || name;
    setWorkstation(workstation.filter((w) => (w.workstation_id || w.workstation_name) !== key));
    setCheckedMap(prev => {
      const map = { ...prev };
      delete map[key];
      return map;
    });
  };

  // Validar y enviar
  const validateAndSubmit = () => {
    const selected = workstation.filter((w) => checkedMap[w.workstation_id || w.workstation_name]);
    if (selected.length === 0) {
      setError("Debes seleccionar al menos una estación.");
      return;
    }
    setError(null);
    setPayload(selected);
    moveFunctions.next();
  };


  return (
    <div className="container-workstation">
      <div className="logo-container-preg">
        <img
          src="/logos/Recurso 40MEDIOPUNTO.png"
          alt="Logo Mediopunto"
          className="registration-logo-preg"
        />
      </div>
      <div className="info-guide-preg">
        <h2 className="Title-Step-Registration-preg">Crea una estación de trabajo </h2>
        <p style={{display:'flex', flexDirection:'column'}}>
          <FontAwesomeIcon icon={faInfoCircle} size="sm" className="info-icon" />
          ¡Perfecto! Ahora que tu local está listo, es momento de crear tus primeras estaciones de trabajo.
          En Medio Punto, una estación de trabajo es el espacio físico donde se realiza cada tarea (por ejemplo: cocina, salón, barra, etc.).
          <span style={{ color: '#FC7556' }}>
            Ten en cuenta que, por defecto, ya hemos creado una estación llamada “caja”, pero podrás modificarla o añadir nuevas estaciones según tus necesidades.
          </span>
        </p>
      </div>
      <p style={{color:'#333'}}>Selecciona las estaciones a registrar:</p>
      <ListGroup className="mb-3" style={{marginLeft:'5rem'}}>
        {workstation.map((w) => {
          const key = w.workstation_id || w.workstation_name;
          return (
            <div className="mediopunto-checkbox-container" key={key}>
              <input
                id={`checkbox-${w.workstation_name}`}
                type="checkbox"
                name="isSelected"
                checked={!!checkedMap[key]}
                onChange={() => toggleChecked(w.workstation_name, w.workstation_id)}
              />
              <label
                htmlFor={`checkbox-${w.workstation_name}`}
                className="mediopunto-checkbox-label"
              ></label>
              <span style={{ marginLeft: 8, color: '#333' }}>
                <strong>{w.workstation_name}</strong>
                {w.workstation_description && (
                  <small>: {w.workstation_description}</small>
                )}
              </span>
              {!["Caja", "Cocina"].includes(w.workstation_name) && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeOption(w.workstation_name, w.workstation_id)}
                  style={{ marginLeft: 'auto' }}
                >
                  <Trash />
                </Button>
              )}
            </div>
          );
        })}
      </ListGroup>
      {error && <Alert variant="danger">{error}</Alert>}
      {!showNewForm && (
        <Button variant="none" className="mp-button orange" style={{border:'1px solid #FC7556'}} onClick={() => setShowNewForm(true)}>
          Crear una nueva estación de trabajo
        </Button>
      )}
      {showNewForm && (
        <div className="new-workstation-form">
          <div className="input-create-workstation">
            <Form.Group className="form-group-preg">
              <Form.Control
                type="text"
                id="workstation_name"
                name="workstation_name"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                required
                className="workstation-input"
                placeholder="Nombre de la Estación"
              />
            </Form.Group>
            <Form.Group className="form-group-preg">
              <Form.Control
                type="text"
                id="workstation_description"
                name="workstation_description"
                value={newDesc}
                onChange={(e) => setNewDesc(e.target.value)}
                className="workstation-input"
                placeholder="Descripción"
              />
            </Form.Group>
          </div>
          <Form.Group className="form-group-preg container-switch-plus">
            <div className="contenedor-switch-span">
              <label className="switch me-2 mb-0">
                <input
                  type="checkbox"
                  checked={newIsCaja}
                  onChange={(e) => setNewIsCaja(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
              <span style={{ color: '#333' }}>¿Es caja?</span>
              <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="tooltip-item-name" >
                      <div style={{ textAlign: 'left', whiteSpace: 'normal' }}>
                        Si seleccionas esta opción, se considerara que la estacion de trabajo puede guardar dinero y realizar transacciones.
                      </div>
                    </Tooltip>
                  }
                >
                  <span className="ms-2 info-create-item" style={{ cursor: 'pointer' }}>
                    <FaInfoCircle  size={15} color="#6c757d" style={{marginLeft:'.5rem'}} />{/* Ícono de ayuda */}
                  </span>
                </OverlayTrigger>
            </div>
            <div className="contenedor-button-plus">
              <Button variant="none" className="button-plus-worktation" onClick={addCustomOption}>
                <FaPlus/>
              </Button>
            </div>
          </Form.Group>
        </div>
      )}
      {/* Botones de navegación */}
      <div className="button-group">
        <Button className="BackStep_Registration-preg" type="button" variant="none" onClick={moveFunctions.back}>
         <ChevronLeft/> Anterior
        </Button>
        <Button className="NextStep_Registration-preg" type="button" variant="none" onClick={validateAndSubmit}>
          Siguiente <ChevronRight/>
        </Button>
      </div>
    </div>
  );
};

export default CreateWorkstation;
